import { render, staticRenderFns } from "./BoardConfiguration.vue?vue&type=template&id=082a1abe&scoped=true&"
import script from "./BoardConfiguration.vue?vue&type=script&lang=js&"
export * from "./BoardConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./BoardConfiguration.vue?vue&type=style&index=0&id=082a1abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a1abe",
  null
  
)

export default component.exports